import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-bmwicon_车漆-27",
  "use": "icon-bmwicon_车漆-27-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 40 40\" id=\"icon-bmwicon_车漆-27\"><path d=\"M36.14,16.13c-1.88-1.88-6.44-1-8.8-.41L18.2,6.86l-.87.88L12.79,3.35,9.17,6.86l4.54,4.39L2.88,21.74v.11L18.2,36.65l14.42-14,6.08,5.88S38.7,18.69,36.14,16.13ZM8,21.74l10.23-9.92,10.22,9.92Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol